import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconCellularDataOn$1 = /*@__PURE__*/ proxyCustomElement(class WppIconCellularDataOn extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-cellular-data-on", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M4.75 12.0001C5.12656 12.0001 5.4383 12.2776 5.49187 12.6393L5.5 12.7501V15.2501C5.5 15.6643 5.16421 16.0001 4.75 16.0001C4.37344 16.0001 4.0617 15.7226 4.00813 15.3609L4 15.2501V12.7501C4 12.3359 4.33579 12.0001 4.75 12.0001ZM7.75 10.0001C8.12656 10.0001 8.4383 10.2776 8.49187 10.6393L8.5 10.7501V15.2501C8.5 15.6643 8.16421 16.0001 7.75 16.0001C7.37344 16.0001 7.0617 15.7226 7.00813 15.3609L7 15.2501V10.7501C7 10.3359 7.33579 10.0001 7.75 10.0001ZM10.75 8.0001C11.1266 8.0001 11.4383 8.27761 11.4919 8.63927L11.5 8.7501V15.2501C11.5 15.6643 11.1642 16.0001 10.75 16.0001C10.3734 16.0001 10.0617 15.7226 10.0081 15.3609L10 15.2501V8.7501C10 8.33588 10.3358 8.0001 10.75 8.0001ZM13.75 6.0001C14.1266 6.0001 14.4383 6.27761 14.4919 6.63927L14.5 6.7501V15.2488C14.5 15.663 14.1642 15.9988 13.75 15.9988C13.3734 15.9988 13.0617 15.7213 13.0081 15.3596L13 15.2488V6.7501C13 6.33588 13.3358 6.0001 13.75 6.0001ZM16.75 4.00003C17.1229 3.99661 17.4344 4.26825 17.4909 4.62563L17.5 4.73523L17.4856 15.2506C17.4896 15.6605 17.1602 15.996 16.75 16.0001C16.3771 16.0036 16.0656 15.7319 16.0091 15.3746L16 15.265L16.0144 4.74963C16.0104 4.33973 16.3398 4.00421 16.75 4.00003Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-cellular-data-on-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-cellular-data-on", "wpp-icon-cellular-data-on-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-cellular-data-on-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-cellular-data-on-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconCellularDataOn$1);
      }
      break;
  } });
}

const WppIconCellularDataOn = WppIconCellularDataOn$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconCellularDataOn, defineCustomElement };
